import { useQueryFetch } from 'sonata-react-components';

import { getCoverageVariables } from '@/services/doohAudience.service';
import { getSocialMediaOptions } from './doohDemography.helpers';

import type { SocialMediaOption } from './doohDemography.helpers';

/** The social media variables of the coverage catalogue of the country (none without country) */
export function useSocialMediaOptions(country?: string): { isLoading: boolean; options: SocialMediaOption[] } {
  const countryCode = country?.toUpperCase();
  const { data, isLoading } = useQueryFetch(
    ['doohDemographySocialMedia', countryCode],
    async () => getSocialMediaOptions(await getCoverageVariables(countryCode!)),
    { enabled: Boolean(countryCode) }
  );

  return { isLoading: Boolean(countryCode) && isLoading, options: data ?? [] };
}
